import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";
import About from "../pages/about/page";
import Search from "../pages/search/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category",
        element: <Category />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "news",
        element: <NewsList />,
      },
      {
        path: "news/:id",
        element: <NewsDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;